import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import styles from "./button.module.css";
import { Slot } from "@shortsworks/ui";

const buttonVariants = cva(styles.button, {
  variants: {
    variant: {
      default: styles.button_default,
      destructive: styles.button_destructive,
      outline: styles.button_outline,
      secondary: styles.button_secondary,
      ghost: styles.button_ghost,
      link: styles.button_link,
    },
    size: {
      default: styles.button_size_default,
      sm: styles.button_size_sm,
      lg: styles.button_size_lg,
      icon: styles.button_size_icon,
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={buttonVariants({ variant, size, className })}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
